import { render, staticRenderFns } from "./CreateLesson.vue?vue&type=template&id=6473ff34&scoped=true"
import script from "./CreateLesson.vue?vue&type=script&lang=js"
export * from "./CreateLesson.vue?vue&type=script&lang=js"
import style0 from "./CreateLesson.vue?vue&type=style&index=0&id=6473ff34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473ff34",
  null
  
)

export default component.exports